import {get, post} from '@/utils/apiBase.js'
// cp订单管理
export const getQuestList = (option) => {
    return get('/apis/project/cp_admin/get_quest_list', option);
};
// 删除投票
export const delQuest = (option) => {
    return post('/apis/project/cp_admin/del_quest', option)
}
// 删除投票问题
export const delQuestVote = (option) => {
    return post('/apis/project/cp_admin/del_quest_vote', option)
}
// 获取投票详情
export const getQuestByQuestId = (option) => {
    return get('/apis/project/cp_admin/get_quest_by_quest_id', option);
};
// 编辑投票信息
export const editQuest = (option) => {
    return post('/apis/project/cp_admin/edit_quest', option)
}
// 更新添加投票
export const add_new_questionnaire = (option) => {
    return post('/apis/project/cp_admin/add_quest', option)
}

// 获取投票数据
export const getQuestData = (option) => {
    return get('/apis/project/cp_admin/get_quest_data', option);
};
// 更新添加投票
const show_vote_list = (option) => {
    return post('/project_new/show_vote_list', option)
}
// 创建投票
const addVoteApi = (option) => {
    return post('/apis/project/cp_admin/add_quest', option)
}
// cp后台获取回报档列表，发布投票时用
export const getRewardListVote = (option) => {
    return get('/apis/project/cp/get_reward_list', option);
};
// 根据更新ID和投票ID获取对应的投票权限
export const getVoteRight = (option) => {
    return get('/apis/project/cp_admin/get_vote_right', option);
};
export default {
    getQuestList,
    delQuest,
    delQuestVote,
    getQuestByQuestId,
    editQuest,
    add_new_questionnaire,
    getQuestData,
    show_vote_list,
    addVoteApi,
    getRewardListVote,
    getVoteRight
};